module.exports = __webpack_public_path__ + "static/media/BackgroundGAPIVertical.6155ba1e.png";